<h2 mat-dialog-title>{{dialogTitle}}</h2>
<form [formGroup]="editUsernameForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ label }}</mat-label>
      <input matInput formControlName="newUsername" required autocomplete="username" />
      @if (editUsernameForm.get('newUsername').hasError('required')) {
        <mat-error>Username is required</mat-error>
      }
    </mat-form-field>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="editUsernameForm.invalid" (click)="onSubmit()">Submit</button>
    </mat-dialog-actions>
  </mat-dialog-content>
</form>
